import { buildLink,Link  } from '@caritas/ui';

export type MenuItem = {
  id: string;
  title: string;
  Link: Link;
  children?: Array<MenuItem>;
  childrenPaths?: Array<string>;
};

export const buildMenuTree = (
  menu: Array<MenuItemFragment> = [],
  parent: string = '',
): Array<MenuItem> =>
  menu
    .filter((item) => item.parent === parent)
    .map((item) => {
      const childrenMenuTree = buildMenuTree(menu, item.id);
      const children = childrenMenuTree.length ? childrenMenuTree : undefined;

      return {
        id: item.id,
        title: item.label,
        Link:
          item.url.length > 0 ? buildLink({ href: item.url }) : buildLink({}),
        children,
        // Allows for setting the active state of a parent menu item
        childrenPaths: children
          ? children.map((child: MenuItem) => child.Link.href)
          : undefined,
      };
    });
